if (!customElements.get('bundle-quantity-selector')) {
  customElements.define(
    'bundle-quantity-selector',
    class BundleQuantitySelector extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.onOptionChange.bind(this));
        const checked = this.querySelector('input[type="radio"]:checked');
        if (checked) this.applyOption(checked, false);
      }

      onOptionChange(event) {
        if (event.target.type !== 'radio') return;
        this.applyOption(event.target, true);
      }

      applyOption(radio, notify) {
        this.querySelectorAll('.bundle-qty__option').forEach((option) => {
          const input = option.querySelector('input[type="radio"]');
          option.classList.toggle('is-selected', Boolean(input && input.checked));
        });

        const quantityInput = document.getElementById(`Quantity-${this.dataset.section}`);
        if (!quantityInput) return;

        quantityInput.value = radio.dataset.quantity;
        if (notify) quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
